import { TrendingUp, DollarSign, Zap, Target, ShoppingCart, Layers, Skull, FlaskConical, MapPin } from "lucide-react";

export function OverviewCards({ overview }) {
  if (!overview) return null;

  const metrics = [
    { label: "ACTIVAS", value: overview.active_brands, icon: Layers, color: "#007AFF" },
    { label: "REVENUE", value: `$${(overview.total_revenue_usd / 1000).toFixed(1)}K`, icon: DollarSign, color: "#34C759" },
    { label: "APIs", value: `$${overview.total_api_cost_usd.toFixed(0)}`, icon: Zap, color: "#FFCC00" },
    { label: "ROI", value: `${overview.roi_pct.toFixed(0)}%`, icon: TrendingUp, color: "#34C759" },
    { label: "VENTAS", value: overview.total_sales.toLocaleString(), icon: ShoppingCart, color: "#007AFF" },
    { label: "SCALING", value: overview.brands_scaling, icon: TrendingUp, color: "#34C759" },
    { label: "TESTING", value: overview.brands_testing, icon: FlaskConical, color: "#FFCC00" },
    { label: "KILLED", value: overview.brands_killed, icon: Skull, color: "#FF3B30" },
    { label: "ZONES", value: overview.territories_monitored, icon: MapPin, color: "#8A2BE2" },
  ];

  return (
    <div data-testid="overview-cards">
      <div className="panel-header">
        <span className="panel-title">
          <Target size={10} strokeWidth={1.5} style={{ display: "inline", marginRight: 6 }} />
          METRICAS GENERALES
        </span>
      </div>
      <div style={{
        display: "grid",
        gridTemplateColumns: "repeat(3, 1fr)",
        gap: 1,
        background: "rgba(255,255,255,0.04)"
      }}>
        {metrics.map((m, i) => {
          const Icon = m.icon;
          return (
            <div key={i} data-testid={`metric-${m.label.toLowerCase().replace(/\s/g, '-')}`} style={{
              padding: "10px 12px",
              background: "#09090b",
              transition: "background 0.15s ease"
            }}>
              <div style={{ display: "flex", alignItems: "center", gap: 4, marginBottom: 4 }}>
                <Icon size={10} strokeWidth={1.5} style={{ color: m.color }} />
                <span className="metric-label">{m.label}</span>
              </div>
              <div className="metric-value" style={{ fontSize: i < 4 ? 24 : 20, color: i < 4 ? "#fff" : "#d4d4d8" }}>
                {m.value}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
